import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'
import { simulateGetUser, doLogout, doGetSession, getScopes, getScopeConfig, getActiveSession } from '../../utilities'

function AppNavbar({ userType: ut, user_session }) {
    const [user, setUser] = React.useState(null)
    const [isLoggedIn, setIsLoggedIn] = React.useState(false)
    const [homeUrl, setHomeUrl] = React.useState('/')
    const [allScopes, setAllScopes] = React.useState([])
    const [session, setSession] = React.useState(null)
    const [userType, setUserType] = React.useState(ut)
    const [activeScope, setActiveScope] = React.useState(null)
    const router = useRouter()

    const getScopConf = (id, isItInit, recache = false) => {
        if (id) getActiveSession(id, recache)
            .then((activeP) => {
                if (activeP) {
                    setActiveScope(activeP)
                    if (!isItInit) {
                        // router.reload()
                        // setTimeout(() => {
                            if (router.pathname !== '/user') {
                                // router.push('/user/surveys')
                                router.push('/user')
                            } else {
                                router.reload()
                            }
                        // }, 1200);
                    }
                }
            })
    }
    const fetchScopes = () => {
        return getScopes()
            .then((data) => {
                if (data.length > 0) {
                    setAllScopes(data)
                }
            })
    }

    React.useEffect(() => {
        let mtd = true
        if (mtd) {
            setUserType(ut)
            // doGetSession().then(session => {
            if (user_session) {
                setSession(user_session)
                setUser(user_session.user)
                setIsLoggedIn(true)
                // setHomeUrl(user_session.user.type === 'admin' ? '/admin' : '/user')
                // let u_t = user_session.user.type;
                // if (u_t) {
                //     if (u_t && u_t.toLocaleLowerCase().includes('ordinator')) {
                //         setHomeUrl('/region')
                //     } else if ((u_t == 'user' || u_t.includes('manager') || u_t == 'participant')) {
                //         setHomeUrl('/user')
                //     } else {
                //         setUserType(null)
                //         setHomeUrl('/')
                //     }
                // }
                if (user_session.activeScopeCode && (userType.toLocaleLowerCase() == 'user' || userType.toLocaleLowerCase().includes('manager') || userType.toLocaleLowerCase() == 'participant')) {
                    getScopConf(user_session.activeScopeCode, true)
                } else {
                    if (
                        router.pathname !== '/user' &&
                        router.pathname !== '/user/settings/account'
                    ) {
                        // router.push('/user', undefined, { unstable_skipClientCache: true })
                    }
                }
            } else {
                router.push('/auth/login', undefined, { unstable_skipClientCache: true })
            }
            // })
            fetchScopes()
            if (typeof window !== 'undefined') {
                const headerMenu = document.getElementById('headerMenu')
                // if site is staging/development, replace class(bg-violet-dark) with bg-amber-700
                if (headerMenu && (window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost'))) {
                    headerMenu.classList.remove('bg-violet-dark')
                    headerMenu.classList.add('bg-amber-700')
                }
            }
        }
        return () => {
            mtd = false
        }
    }, [])
    return (
        <>
            {((window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost'))) && <div style={{padding: '4px', textAlign: 'center', zIndex: 9999, position: 'fixed', backgroundColor: 'white', width: '100vw', marginBottom: '5px'}}>
                <small>This is a training instance of the ePT platform for testing and training purposes only. For the live site, go to <Link href={'https://ept.nphl.go.ke'} target='_blank'>https://ept.nphl.go.ke</Link></small>
            </div>}
            <nav id="headerMenu" style={{top: ((window.location.hostname.includes('-pilot') || window.location.hostname.includes('-training')  || window.location.hostname.includes('localhost'))) ? '25px' : '0px'}} className="navbar navbar-expand-lg navbar-dark fixed-top bg-slate-700">
                <div className="container-fluid">
                    {/* <Link legacyBehavior href={homeUrl}>
                        <a className="navbar-brand">{activeScope}</a>
                    </Link> */}
                    <Link href={'/'} style={{textDecoration: 'none'}}>

                        <div className='d-flex flex-column mb-lg-2 mx-1'>
                            <img src='/images/gok.png' alt='GOK MOHLogo' style={{ width: '40px', height: 'auto' }} />
                            <small className='text-white text-center fw-bold'>EPT</small>
                        </div>

                    </Link>
                    <div className='d-flex flex-column align-items-center'>
                        {/* {user?.orgunits && user?.orgunits.length > 0 && (
                            <span className='text-violet-300 text-smallest'>{user.orgunits[0]?.name}</span>
                        )} */}
                        {((userType.toLocaleLowerCase() == 'user' || userType.toLocaleLowerCase().includes('manager') || userType.toLocaleLowerCase() == 'participant')) ? (allScopes && allScopes.length > 0 ? <div className="btn-group fw-bold scopeSwitcher">
                            <button className="btn bg-slate-800 btn-sm px-md-3 py-xl-2 text-white btn-sm dropdown-toggle fw-semibold" type="button" data-bs-toggle="dropdown" title={activeScope ? allScopes.find(ap => ap.uuid == activeScope)?.name : "Select a scope"} aria-expanded="false" style={{ fontSize: (activeScope ? '1.2em' : '0.9em') }}>
                                {activeScope ? <>{allScopes.find(ap => ap.uuid == activeScope)?.name?.slice(0, 25) + ''}{activeScope && allScopes.find(ap => ap.uuid == activeScope)?.name?.length > 25 && <>&hellip;</>}</> : <>Select a Scope</>}
                            </button>
                            <ul className="dropdown-menu">
                                {allScopes.map((ap, x) => <li key={ap.uuid}><a className="dropdown-item" style={{ cursor: 'pointer', fontWeight: (ap.uuid == activeScope ? 'bold' : 'normal') }} onClick={(ev) => {
                                    ev.preventDefault()
                                    getScopConf(ap.uuid, false, true);
                                    // redirect to user page
                                    router.push('/user')
                                }}>{ap && ap?.name ? ap?.name : "Scope"}</a></li>)}
                            </ul>
                        </div> : <h5 className="text-white mb-0">
                            <Link href="/" style={{ textDecoration: 'none', color: '#fff' }}>EPT</Link>
                        </h5>) : <h5 className="text-white mb-0">
                            <Link href="/" style={{ textDecoration: 'none', color: '#fff' }}>EPT</Link>
                        </h5>}
                    </div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#appNavbarToggler" aria-controls="appNavbarToggler" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="appNavbarToggler">
                        {userType ? <>
                            {(userType.toLocaleLowerCase() == 'user' || userType.toLocaleLowerCase().includes('manager') || userType.toLocaleLowerCase() == 'participant') ? <ul className="navbar-nav appnavbar me-auto mb-2 mb-lg-0">
                                <li className="nav-item mx-xl-2">
                                    <Link href={'/user'} className={"nav-link " + ((router.pathname === '/' || router.pathname === '/user') ? ' active' : '')}>Home</Link>
                                </li>
                                <li className="nav-item mx-xl-2">
                                    <Link href="/user/evaluations" className={"nav-link " + ((router.pathname === '/user/evaluations' || router.pathname == '/user/evaluations/[evaluation]/new') ? ' active' : '')}>Results entry</Link>
                                </li>
                                {userType.toLocaleLowerCase().includes('manager') && <li className="nav-item mx-xl-2">
                                    <Link href="/user/manage-unit" className={"nav-link " + (router.pathname === '/user/manage-unit' ? ' active' : '')}>Manage Laboratory</Link>
                                </li>}
                                <li className="nav-item mx-xl-2">
                                    <Link href="/user/surveys" className={"nav-link " + (router.pathname === '/user/surveys' ? ' active' : '')}>Surveys</Link>
                                </li>
                                {/* <li className="nav-item mx-xl-2">
                                    <Link legacyBehavior href="/user/reports"><a className={"nav-link " + (router.pathname === '/user/reports' ? ' active' : '')}>Reports</a></Link>
                                </li> */}
                                <li className="nav-item mx-xl-2">
                                    <Link href="/learning-centre" className={"nav-link " + (router.pathname === '/user/settings' ? ' active' : '')}>Help</Link>
                                </li>
                            </ul> : (
                                userType.toLocaleLowerCase() == 'partner' ? <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                    {/* <PARTNER */}
                                    <li className="nav-item mx-xl-2">
                                        <Link href={'/partner'} className={"nav-link " + (router.pathname === '/' ? ' active' : '')}>Home</Link>
                                    </li>
                                    <li className="nav-item mx-xl-2">
                                        <Link href="/partner/units" className={"nav-link " + (router.pathname === '/partner/units' ? ' active' : '')}>Organization Units</Link>
                                    </li>
                                    <li className="nav-item mx-xl-2">
                                        <Link href="/partner/analytics" className={"nav-link " + (router.pathname === '/partner/analytics' ? ' active' : '')}>Analytics</Link>
                                    </li>
                                    {/* PARTNER/> */}
                                </ul> : (
                                    userType.toLocaleLowerCase().includes('ordinator') || userType.toLocaleLowerCase().includes('county') ? <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                        {/* <REGIONAL */}
                                        <li className="nav-item mx-xl-2">
                                            <Link href={'/region'} className={"nav-link " + (router.pathname === '/' ? ' active' : '')}>Organisation Units</Link>
                                        </li>
                                        <li className="nav-item mx-xl-2">
                                            <Link href="/region/activity" className={"nav-link " + (router.pathname === '/region/activity' ? ' active' : '')}>Enrolments &amp; Participation</Link>
                                        </li>
                                        <li className="nav-item mx-xl-2">
                                            <Link href="/region/analytics" className={"nav-link " + (router.pathname === '/region/analytics' ? ' active' : '')}>Analytics</Link>
                                        </li>
                                        {/* REGIONAL/> */}
                                    </ul> : null
                                )
                            )}
                        </> : <>no userType</>}
                        {(isLoggedIn && user) &&
                            <div className='d-flex flex-column'>
                                <div className="btn-group">
                                    <button className="btn bg-slate-800 text-white btn-sm dropdown-toggle outline-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {user.name}
                                    </button>
                                    <ul className="dropdown-menu text-center">
                                        <li>
                                            <Link href="/user/settings/account" className="nav-link w-100">
                                                My Account
                                            </Link>
                                        </li>
                                        <li><hr className="dropdown-divider" /></li>
                                        {/* <li>
                                            <Link legacyBehavior href="/user/settings">
                                                <a className="nav-link w-100">Settings</a>
                                            </Link>
                                        </li>
                                        <li><hr className="dropdown-divider" /></li> */}
                                        <li className='d-flex justify-content-center'>
                                            <button className="btn btn-link nav-link text-center w-100" onClick={ev => { doLogout(router) }}>Logout</button>
                                        </li>
                                    </ul>
                                </div>
                                {user?.orgunits && user?.orgunits.length > 0 && <span className='text-smallest text-violet-100'>{user.orgunits[0]?.name}</span>}
                            </div>}
                    </div>
                </div>
            </nav>
        </>
    );
}

export default AppNavbar